import React from 'react'

export default function DashboardSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <g clipPath="url(#clip0_27932_18104)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.65067 0C1.21288 0 0.793029 0.173909 0.483469 0.483469C0.173909 0.793029 0 1.21288 0 1.65067V5.46044C0 6.37244 0.738667 7.11111 1.65067 7.11111H5.46044C5.89823 7.11111 6.31808 6.9372 6.62764 6.62764C6.9372 6.31808 7.11111 5.89823 7.11111 5.46044V1.65067C7.11111 1.21288 6.9372 0.793029 6.62764 0.483469C6.31808 0.173909 5.89823 0 5.46044 0H1.65067ZM10.5396 0C10.1018 0 9.68192 0.173909 9.37236 0.483469C9.0628 0.793029 8.88889 1.21288 8.88889 1.65067V5.46044C8.88889 6.37244 9.62756 7.11111 10.5396 7.11111H14.3493C14.7871 7.11111 15.207 6.9372 15.5165 6.62764C15.8261 6.31808 16 5.89823 16 5.46044V1.65067C16 1.21288 15.8261 0.793029 15.5165 0.483469C15.207 0.173909 14.7871 0 14.3493 0H10.5396ZM1.65067 8.88889C1.21288 8.88889 0.793029 9.0628 0.483469 9.37236C0.173909 9.68192 0 10.1018 0 10.5396V14.3493C0 15.2613 0.738667 16 1.65067 16H5.46044C5.89823 16 6.31808 15.8261 6.62764 15.5165C6.9372 15.207 7.11111 14.7871 7.11111 14.3493V10.5396C7.11111 10.1018 6.9372 9.68192 6.62764 9.37236C6.31808 9.0628 5.89823 8.88889 5.46044 8.88889H1.65067ZM10.5396 8.88889C10.1018 8.88889 9.68192 9.0628 9.37236 9.37236C9.0628 9.68192 8.88889 10.1018 8.88889 10.5396V14.3493C8.88889 15.2613 9.62756 16 10.5396 16H14.3493C14.7871 16 15.207 15.8261 15.5165 15.5165C15.8261 15.207 16 14.7871 16 14.3493V10.5396C16 10.1018 15.8261 9.68192 15.5165 9.37236C15.207 9.0628 14.7871 8.88889 14.3493 8.88889H10.5396Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_27932_18104">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
